var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "s-item"
  }, [_c('div', {
    staticClass: "s-item-info"
  }, [_c('div', {
    staticClass: "s-space-y-2 s-mr-auto w-full"
  }, [_vm.fields.length > 0 ? _vm._l(_vm.fields, function (field, i) {
    return _c('p', {
      key: i,
      staticClass: "s-text-gray s-text-xs"
    }, [_vm._v(" " + _vm._s(field.value) + _vm._s(_vm.getFieldValue(field)) + " ")]);
  }) : [_c('p', {
    staticClass: "s-text-gray s-text-xs s-whitespace-nowrap"
  }, [_vm._v(" 預約時間：" + _vm._s(_vm.bookingDateText) + " ")]), _c('p', {
    staticClass: "s-text-gray s-text-xs s-whitespace-nowrap"
  }, [_vm._v(" 預約狀態：" + _vm._s(_vm.booking.status) + " ")])], _c('div', {
    staticClass: "w-full d-flex align-items-start justify-content-end"
  }, [_vm._l(_vm.bookingStatusMapping.inform_button, function (sdConfig, index) {
    return _c('div', {
      key: 'inform-' + index
    }, [_c('StatusDetector', {
      attrs: {
        "status": _vm.booking.status,
        "config": sdConfig,
        "enviroment": "liff",
        "page": "list"
      }
    })], 1);
  }), _vm._l(_vm.bookingStatusMapping.status_change_button, function (sdConfig, index) {
    return _c('div', {
      key: 'status-change-' + index
    }, [_c('StatusDetector', {
      attrs: {
        "status": _vm.booking.status,
        "config": sdConfig,
        "enviroment": "liff",
        "page": "list"
      },
      on: {
        "buttonAction": _vm.updateStatus
      }
    })], 1);
  }), _vm.isCanView ? _c('div', {
    staticClass: "mr-2"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary list-button",
    attrs: {
      "variant": "outline-dark",
      "block": ""
    },
    on: {
      "click": function click($event) {
        return _vm.goToView();
      }
    }
  }, [_vm._v(" 查看 ")])], 1) : _vm._e(), _vm.isCanReadOnly ? _c('div', {
    staticClass: "mr-2"
  }, [_c('SharedButton', {
    staticClass: "s-btn-outline-primary list-button",
    attrs: {
      "variant": "outline-dark",
      "block": ""
    },
    on: {
      "click": function click($event) {
        return _vm.goToReadOnly();
      }
    }
  }, [_vm._v(" 檢視 ")])], 1) : _vm._e(), _vm.isCanEdit ? _c('div', [_c('SharedButton', {
    staticClass: "s-btn-outline-primary list-button",
    attrs: {
      "variant": "outline-dark",
      "block": ""
    },
    on: {
      "click": function click($event) {
        return _vm.goToEdit();
      }
    }
  }, [_vm._v(" 編輯 ")])], 1) : _vm._e()], 2)], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }